<template>
    <div class="details">
      <!-- 其他详情页面 -->
        <div class="otherPage" v-if="type == 0">
                <div class="otherPage-header">
                  <div class="header-left" @click="back">
                      <span class="iconfont iconzuojiantou"></span>
                  </div>
                  <div class="header-center">
                      <p>{{townStreet? townStreet:'虎门镇'}}</p>
                  </div>
                  <div class="header-right">
                    
                  </div>
                </div>
              <!-- 轮播图 -->
              <div class="otherPage-swiper" v-if="BannerPicture.length > 0">
                  <swiper :options="swiperOption">
                      <swiper-slide v-for="(item,index) in BannerPicture" :key="index">
                          <img :src="item.Url" alt="">
                      </swiper-slide>
                  <div class="swiper-pagination"  slot="pagination"></div>
                </swiper>
             </div>
              <!-- 信息 -->
              <div class="otherPage-message" v-if="ContentType == '不预订' || ContentType == '按平方' || ContentType == '按数量'">
                  <p class="title">{{ContentTitle}}</p>
                  <!-- <p class="content" v-if="ContentDescription">{{ContentDescription}}</p> -->
                  <p class="content" v-if="ContentDescription" v-html="ContentDescription"></p>
              </div>
              <!-- 服务介绍 -->
              <div class="otherPage-presentation">
                 <!--  <p>{{ContentFlag}}</p> -->
                  <div class="presentationImg" v-for="(item,index) in ContentPicture" :key="index" @click="toDetails(item.Link,item.LinkType)">
                      <img :src="item.Url" alt="">
                  </div>
              </div>
                <!-- 脚步按钮 -->
                <div class="otherPage-foot" v-if="ContentType !== '无按钮'">
                  <div class="button" ><a href="tel:4001500600">联系客服</a></div>
                  <div class="button" @click="otherOrder" v-if="ContentType !== '不预订'">立即预订</div>
                </div>
        </div>
      <!-- 家庭保洁详情页面 -->
      <div class="dailyPage" v-else-if="type == 1">
            <div class="dailyPage-header">
              <div class="header-left" @click="back">
                    <span class="iconfont iconzuojiantou"></span>
                </div>
                <div class="header-center">
                    <p>家庭保洁</p>
                </div>
                <div class="header-right" @click="toHome">
                  <span class="iconfont iconshouye"></span>
                </div>
            </div>
          
          <!-- 轮播图 -->
          <div class="dailyPage-swiper">
                <swiper :options="swiperOption">
                    <swiper-slide v-for="(item,index) in BannerPicture" :key="index">
                        <img :src="item.Url" alt="">
                    </swiper-slide>
                <div class="swiper-pagination"  slot="pagination"></div>
                </swiper>
          </div>
          <!-- 标题 -->
          <div class="dailyPage-title">
            <p>{{ContentTitle}}</p>
            <p style="margin-top: 6px;font-size: 16px;">（3小时起预约）</p>
          </div>
          <!-- 服务介绍 -->
          <div class="dailyPage-presentation">
            <div class="presentationImg" v-for="(item,index) in ContentPicture" :key="index">
                    <img :src="item.Url" alt="">
              </div>
          </div>
          <!-- 脚步按钮 -->
          <div class="dailyPage-foot">
                <div class="kf-button"><a href="tel:4001500600"><span class="iconfont icondianhua"></span>客服</a></div>
                <div class="zd-button" @click="zdOrder">钟点预约</div>
                <div class="dq-button" @click="dqOrder">定期预约</div>    
          </div>
      </div>

     <!-- 家装建材 -->
       <div class="decorationPage" v-else-if="type == 2">
         <div class="decorationPage-header">
              <div class="header-left" @click="back">
                    <span class="iconfont iconzuojiantou"></span>
                </div>
                <div class="header-center">
                    <p>家装建材</p>
                </div>
                <div class="header-right" @click="toHome">
                  <span class="iconfont iconshouye"></span>
                </div>
          </div>
          <!-- 标签页 -->
          <van-tabs type="card" class="decorationPage-type">
            <van-tab title="装修服务">
              <div class="content">
                <div class="imgs" v-for="(item,index) in fwArr" :key="index" @click="toDetails(item.Link,item.LinkType)"> 
                  <img :src="item.Url" alt="">
                </div>
              </div>
            </van-tab>
            <van-tab title="装修建材">
               <div class="content">
                <div class="imgs" v-for="(item,index) in jcArr" :key="index" @click="toDetails(item.Link,item.LinkType)">
                  <img :src="item.Url" alt="">
                </div>
              </div>
            </van-tab>
          </van-tabs>
       </div>
  
    </div>
</template>

<script>
import {mapState} from 'vuex'
import { Toast } from 'vant'
export default {
    data () {
      return {
        swiperOption:{
            pagination: {
            el: '.swiper-pagination'
            },
            loop: true,
            autoplay: 5000
          },
         type:this.$route.query.bj,
         BannerPicture:[],
         ContentTitle:'',
         ContentDescription:'',
         ContentFlag: '',
         Pictures:{},
         ContentPicture:[],
         ServiceFlowPicture:[],
         fwArr:[],
         jcArr:[],
         ContentType: '',
         ContentId: null,
         CanOrder:0, // 1-可预订
         CanNotOrderTips: "",//不可预订时提示
      }
    },
    computed: {
      ...mapState(['townStreet'])
    },
    created () {
       this.getData()
       
    },
    methods: {
      getData () {
          
        let key = this.$route.query.by  === 'sid' ? 'ServiceId' : 'ContentId'
        let id = this.$route.query.id
        this.$axios.get('/api/DjOrder/GetContentInfo',{
          params: {

            [key]: id
          }
       }).then(res => {
          let data = res.data
         // console.log(data)
            this.CanOrder = data.CanOrder
            this.CanNotOrderTips = data.CanNotOrderTips
           let BannerPicture = JSON.parse(data.BannerPicture)

           if (BannerPicture.length > 0) {
             this.BannerPicture = JSON.parse(data.BannerPicture)
           }else{

             if (process.env.NODE_ENV === "development"){
               this.BannerPicture = JSON.parse(data.Pictures).BannerPicture.map((i) => {
                i.Url = 'http://www.lungchuenjz.cn' + i.Url
                return i
              })
             }else{
               this.BannerPicture = JSON.parse(data.Pictures).BannerPicture
             }
             
           }
         
          this.ContentTitle = data.ContentTitle
          if(data.ContentDescription){
            this.ContentDescription = data.ContentDescription.replace(/\n/g, '<br/>').replace(/ /g, '&nbsp;')
          }
          this.Pictures = JSON.parse(data.Pictures)
          if (process.env.NODE_ENV === "development"){
            this.ContentPicture = JSON.parse(data.Pictures).ContentPicture.map((i) => {
                i.Url = 'http://www.lungchuenjz.cn' + i.Url
                return i
            })
            this.ServiceFlowPicture = JSON.parse(data.Pictures).ServiceFlowPicture.map((i) => {
                i.Url = 'http://www.lungchuenjz.cn' + i.Url
                return i
            })
          }else{
            this.ContentPicture = JSON.parse(data.Pictures).ContentPicture
            this.ServiceFlowPicture = JSON.parse(data.Pictures).ServiceFlowPicture
          }

          
            this.ContentFlag = data.ContentFlag
            
           this.ContentPicture.forEach((i) => {
              if (i.Name == '装修服务') {
                  this.fwArr.push(i)
              }
            })
            
            this.ContentPicture.forEach((i) => {
              if (i.Name == '装修建材') {
                  this.jcArr.push(i)
              }
            })
           this.ContentType = data.ContentType

           // console.log(this.Pictures)
           this.ContentId = data.ContentId

           
           
       })
      },
      back () {
        this.$router.back()
      },
      toHome () {
        this.$router.push('/')
      },
      zdOrder () {
        if(this.CanOrder == 0){
          Toast(this.CanNotOrderTips);
          return
        }

        if(localStorage.getItem('kjToken') || this.cookieUtil.getCookie('kjToken')){
          this.$router.push(`/hoursorder`)
        }else{ // 没登录跳转登录页面
          Toast('请先登录！');
          localStorage.setItem('loginPath', '/hoursorder') // 记录登陆前路径
          this.cookieUtil.setCookie('loginPath','/hoursorder')
          this.$router.push(`/wxlogin`)
        }
        
      },
      dqOrder () {
        if(this.CanOrder == 0){
          Toast(this.CanNotOrderTips);
          return
        }
        
        if(localStorage.getItem('kjToken') || this.cookieUtil.getCookie('kjToken')){
          this.$router.push(`/periodicorder`)
        }else{ // 没登录跳转登录页面
          Toast('请先登录！');
          localStorage.setItem('loginPath', '/periodicorder') // 记录登陆前路径
          this.cookieUtil.setCookie('loginPath','/periodicorder')
          this.$router.push(`/wxlogin`)
        }
      },
      otherOrder () {
        if(this.CanOrder == 0){
          Toast(this.CanNotOrderTips);
          return
        }
        
        let id = this.$route.query.id
        let by = this.$route.query.by
        if (this.ContentType == '按平方') {

            
            if(localStorage.getItem('kjToken') || this.cookieUtil.getCookie('kjToken')){
                this.$router.push(`/areaorder?id=${id}&by=${by}`)
              }else{ // 没登录跳转登录页面
                Toast('请先登录！');
                localStorage.setItem('loginPath', `/areaorder?id=${id}&by=${by}`) // 记录登陆前路径
                this.cookieUtil.setCookie('loginPath',`/areaorder?id=${id}&by=${by}`)
                this.$router.push(`/wxlogin`)
              }

        }else if(this.ContentType == '按数量'){
            
    
           if(localStorage.getItem('kjToken') || this.cookieUtil.getCookie('kjToken')){
                this.$router.push(`/quantityorder?id=${id}&by=${by}`)
              }else{ // 没登录跳转登录页面
                Toast('请先登录！');
                localStorage.setItem('loginPath', `/quantityorder?id=${id}&by=${by}`) // 记录登陆前路径
                this.cookieUtil.setCookie('loginPath',`/quantityorder?id=${id}&by=${by}`)
                this.$router.push(`/wxlogin`)
              }

        }else {
          
          if(localStorage.getItem('kjToken') || this.cookieUtil.getCookie('kjToken')){
                this.$router.push(`/cooperationorder?id=${id}&by=${by}`)
              }else{ // 没登录跳转登录页面
                Toast('请先登录！');
                localStorage.setItem('loginPath', `/cooperationorder?id=${id}&by=${by}`) // 记录登陆前路径
                this.cookieUtil.setCookie('loginPath',`/cooperationorder?id=${id}&by=${by}`)
                this.$router.push(`/wxlogin`)
              }
        }
      },
      toDetails (Link,LinkType) {
         if(LinkType == 'NotLink'){
            console.log('不跳转')
            return
          }else if(LinkType == 'ToUrl'){
            this.$router.push(Link)
          }else if(LinkType == 'ShowTips'){
            Toast(Link);
          }
      }
    },
    watch: {
      $route(to,from){
       // this.getData()
       //this.$router.go(0)
       location.reload()
       

     }
    }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.details
  background: rgb(240, 240, 240)
  height: 100%
  .otherPage-header
    width: 100%
    display: flex
    justify-content: space-between
    width: 100%
    height: 40px
    align-items: center
    font-weight: bold
    border-bottom: 1px solid #eee
    background: #009933
    color: white
    .header-left
      margin-left: 8px
      height: 100%
      width: 40px
      display: flex
      align-items: center
    .header-right
      margin-right: 8px
      width: 40px
      height: 100%
      display: flex
      align-items: center
      justify-content: flex-end
  .otherPage-swiper
    width: 100%
    margin-bottom: 8px
    & img
      width: 100%
  .otherPage-message
   width: 100%
   background: white
   margin-bottom: 5px
   padding: 8px
   box-sizing: border-box
   &>.title
     font-size: 16px
     margin-bottom: 5px
   &>.content
     font-size: 14px
     color: #999999
     border: 1px solid #bfbfbf
     border-radius: 6px
     padding: 8px
     background: rgb(240, 240, 240)
     line-height: 18px
  .otherPage-presentation
    margin: 0px auto 44px 
    width: 100%
    background: white
    box-sizing: border-box
    padding: 8px
    .presentationImg
      width: 100%
      &>img
        width: 100%
        margin-top: 10px
  .otherPage-foot
    width: 100%
    background: white
    position: fixed
    left: 0
    right: 0
    bottom: 0
    display: flex
    justify-content: space-around
    border-top 1px solid #d7d7d7 
    & a
      color white
    &>.button
      height 44px
      flex-grow: 2
      margin: 5px 4px
      border-radius: 8px
      background: #c21a1a
      color: white
      display flex
      align-items center
      justify-content center
      font-size 14px
      &:first-child
        background: #009933
        flex-grow: 1
      &:first-child>a
        display: inline-block
        width 100%
        height 100%
        display flex
        align-items center
        justify-content center
        
  .dailyPage-header
    width: 100%
    display: flex
    justify-content: space-between
    width: 100%
    height: 40px
    align-items: center
    font-weight: bold
    border-bottom: 1px solid #eee
    background: white
    position: fixed
    left: 0
    right: 0
    top: 0
    z-index: 90
    .header-left
      margin-left: 8px
      height: 100%
      width: 40px
      display: flex
      align-items: center
    .header-right
      margin-right: 8px
      width: 40px
      height: 100%
      display: flex
      align-items: center
      justify-content: flex-end
      &>span
       font-size: 20px
  .dailyPage-swiper
    width: 100%
    & img
      width: 100%
  .dailyPage-title
    width: 100%
    height: 60px
    margin-top: 10px
    margin-bottom: 10px
    background: white
    line-height: 50px
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    &>p
     font-size: 20px
     color: red
     line-height: 1
  .dailyPage-presentation
    width: 100%
    margin-bottom: 60px
    .presentationImg
      width: 100%
      &>img 
        width: 100%
  .dailyPage-foot
    width: 100%
    background: white
    position: fixed
    left: 0
    right: 0
    bottom: 0
    display: flex
    justify-content: space-around
    align-items: center
    border-top 1px solid #d7d7d7 
    padding: 0px 4px
    box-sizing: border-box
    .zd-button
      width: 38%
      height 44px
      margin: 5px 0
      border-radius: 8px
      background: #c21a1a
      color: white
      display flex
      align-items center
      justify-content center
      font-size 14px
    .dq-button
      width: 38%
      height 44px
      margin: 5px 0
      border-radius: 8px
      background: #f7bb4b
      color: white
      display flex
      align-items center
      justify-content center
      font-size 14px
    .kf-button
      width: 20%
      height 44px
      margin: 5px 0
      border-radius: 8px
      background: #009933
      color: white
      display flex
      align-items center
      justify-content center
      font-size 14px
      & a
        color white
        display: inline-block
        width 100%
        height 100%
        display flex
        align-items center
        justify-content center
      .icondianhua
        font-size: 14px
        margin-right: 2px
  .decorationPage-header
    width: 100%
    display: flex
    justify-content: space-between
    width: 100%
    height: 40px
    align-items: center
    font-weight: bold
    border-bottom: 1px solid #eee
    background: white
    .header-left
      margin-left: 8px
      height: 100%
      width: 40px
      display: flex
      align-items: center
    .header-right
      margin-right: 8px
      width: 40px
      height: 100%
      display: flex
      align-items: center
      justify-content: flex-end
      &>span
       font-size: 20px
  .decorationPage-type
    width: 100%
    >>> .van-tabs__nav--card
      margin: 0
    & img
      width: 100%
      
    

   
</style>



// WEBPACK FOOTER //
// src/pages/More/ServiceDetails/ServiceDetails.vue